<div class="accordion-title">
  <ng-content select="[accordion-title]" />
  @if (expandable) {
    <ac-icon
      class="c-primary cursor-pointer origin-center"
      name="chevron-down"
      [@accordIndicatorAnimation]="_expanded() ? 'expanded' : 'collapsed'"
      (click)="toggle()"
      size="small"
    />
  }
</div>
<div class="accordion-content" [@accordBodyAnimation]="_expanded() ? 'expanded' : 'collapsed'">
  <ng-content />
</div>
